export const getUserDivision = (divisionList, userDivisions) => {
  let userDivisionList = [];
  let defaultDivisionId = null;

  const isSuperUser = userDivisions.some(
    (division) => division.divisionId === 0
  );

  if (isSuperUser) {
    userDivisionList = divisionList;
  } else {
    userDivisionList = divisionList.filter((division) =>
      userDivisions.some(
        (userDivision) => userDivision.divisionId === division.divisionId
      )
    );
  }

  const userDefaultDivision = userDivisions.find(
    (division) => division.isDefault
  )?.divisionId;

  if (userDefaultDivision) {
    defaultDivisionId = userDefaultDivision;
  } else if (userDivisionList.length > 0) {
    defaultDivisionId = userDivisionList[0].divisionId;
  }

  return { userDivisionList, defaultDivisionId };
};